import {
  getOrderLineItemSurchargeValue,
  getOrderLineItemTotalPrice,
} from "~/features/orders/common/utils/OrderLineItemUtils";
import { IncludedSurcharge } from "~/domains/product/components/ProductParams";
import { type OrderLineItemData } from "~/domains/orders/types/modelsV2";
import {
  NetPrice as BaseNetPrice,
  TotalNetPrice as BaseTotalPrice,
} from "~/domains/pricing/components/Price/v2/NetPrice";
import { useTranslation } from "react-i18next";
import { type QuoteLineItem } from "~/features/orders/quoteList/api/fetchOrderDetails/dto";

interface Params {
  className?: string;
  data: OrderLineItemData | QuoteLineItem;
  isBold?: boolean;
}

export const NetPrice = ({ data, className }: Params) => {
  const { t } = useTranslation();
  return (
    <BaseNetPrice
      price={data.netPrice}
      className={className}
      classes={{
        root: "scha__order-table__header",
        price: "scha__order-table__header__title scha__order-table__header__title--light",
      }}
      extraLabelsEnabled={false}
      zeroText={t("product.priceOnRequest")}
    />
  );
};

export const TotalPrice = ({ data, className, isBold = true }: Params) => {
  return (
    <BaseTotalPrice
      price={getOrderLineItemTotalPrice(data)}
      className={className}
      classes={{
        root: "d-flex flex-direction-column",
        price: `${isBold ? "f-bold" : ""} scha__order-table__header__title`,
      }}
    />
  );
};

export const Surcharge = ({ data, className }: Params) => {
  const surcharge = getOrderLineItemSurchargeValue(data);
  if (surcharge.value === 0) {
    return null;
  }
  return <IncludedSurcharge className={className} value={surcharge} percent={data.netPrice.surcharge} />;
};

export const OrderLineItemElements = {
  NetPrice,
  TotalPrice,
  Surcharge,
};
